export default __webpack_public_path__ + "static/media/Inroom nodes.1fedd092.jpg";